import { reduxForm } from 'redux-form';

import MemberForm from './MemberForm';

export default reduxForm({ form: 'memberForm' })(MemberForm);
